module.exports = __webpack_public_path__ + "static/media/typescript.18e17501.png";